import React, { useEffect, useRef, useState } from 'react'

const useShowNavBarMenu = () => {
    const [showUserMenu, setShowUserMenu] = useState(false)

    const userMenuRef = useRef();

    useEffect(() => {
        const handler = (event) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
        }
        document.addEventListener("mousedown", handler)

        return () => {
            document.removeEventListener("mousedown", handler)
        }

    }, [])


    return { showUserMenu, userMenuRef, setShowUserMenu }
}

export default useShowNavBarMenu